import React from 'react'
import PropTypes from 'prop-types'
import { Grid, Box, Flex, Image } from '@chatterbug/aaron'

import { t } from 'src/lib/i18n-react'
import PageWrapupCard from 'src/ui/PageWrapup/subcomponents/PageWrapupCard/PageWrapupCard'
import WrapupCardVocabularyGroup from 'src/pages/ActivityWrapup/subcomponents/WrapupCardVocabularyGroup/WrapupCardVocabularyGroup'

import tutorIcon from './assets/tutor.svg'

const WrapupCardWriting = ({ correctionsRequested, vocabularyGroups }) => {
  if (
    !correctionsRequested &&
    !vocabularyGroups.some((group) => group.items?.length > 0)
  ) {
    return null
  }

  return (
    <PageWrapupCard>
      <Grid columns={1} gridGap={{ _: '3x', tablet: '5x' }}>
        {correctionsRequested && (
          <Box>
            <Box variant="text.h5" mb="0,5x">
              {t('Submitted to tutor')}
            </Box>
            <Flex flexWrap="nowrap" alignItems="flex-start">
              <Image
                src={tutorIcon}
                width={24}
                alt={t('Submitted to tutor')}
                flexShrink={0}
              />
              <Box variant="text.paragraph" color="gray60" ml="0,5x">
                {t('You will receive an email once your entry is corrected. ')}
              </Box>
            </Flex>
          </Box>
        )}
        {vocabularyGroups.map((group, index) => (
          <WrapupCardVocabularyGroup key={index} {...group} />
        ))}
      </Grid>
    </PageWrapupCard>
  )
}

WrapupCardWriting.propTypes = {
  correctionsRequested: PropTypes.bool,
  vocabularyGroups: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default WrapupCardWriting
